// English translations for PRIVIA YACHTS
export const translations = {
  // Navigation
  nav: {
    home: 'Home',
    collection: 'Collection',
    destinations: 'Destinations',
    services: 'Services',
    about: 'About',
    contact: 'Contact'
  },
  
  // Hero section
  hero: {
    title: 'Private Journeys Perfected',
    subtitle: 'Discover the world\'s most exclusive yachts',
    description: 'Experience luxury redefined with our curated collection of superyachts, where every detail is crafted for the discerning traveler.',
    cta: 'Explore Collection',
    stats: {
      yachts: 'Exclusive Yachts',
      destinations: 'Destinations',
      experience: 'Years Experience'
    }
  },
  
  // Collection page
  collection: {
    title: 'Yacht Collection',
    subtitle: 'Discover Our Fleet',
    loading: 'Loading...',
    perDay: 'per day',
    guests: 'guests',
    crew: 'crew',
    viewDetails: 'View Details',
    bookNow: 'Book Now'
  },
  
  // Yacht detail page
  detail: {
    // Quick info
    length: 'Length',
    guests: 'Guests',
    crew: 'Crew',
    perDay: 'Per Day',
    
    // Sections
    artOfTravel: 'The Art of Travel',
    exceptionalExperience: 'An Exceptional Experience',
    accommodation: 'Accommodation',
    presentation: 'Presentation',
    configuration: 'Configuration',
    suites: 'suites',
    cabins: 'cabins',
    maximum: 'Maximum',
    
    // Equipment
    exceptionalEquipment: 'Exceptional Equipment',
    luxuryRefinement: 'Luxury & Refinement',
    
    // Specifications
    technicalSpecs: 'Technical Specifications',
    performanceDesign: 'Performance & Design',
    beam: 'Beam',
    draft: 'Draft',
    maxSpeed: 'Max Speed',
    cruisingSpeed: 'Cruising Speed',
    range: 'Range',
    builder: 'Builder',
    year: 'Year',
    fuel: 'Fuel',
    engines: 'Engines',
    materials: 'Materials',
    hull: 'Hull',
    superstructure: 'Superstructure',
    design: 'Design',
    exterior: 'Exterior',
    interior: 'Interior',
    tonnage: 'Tonnage',
    
    // Pricing & Destinations
    pricingDestinations: 'Pricing & Destinations',
    seasonsRegions: 'Seasons & Cruising Regions',
    summer: 'SUMMER',
    winter: 'WINTER',
    highSeason: 'High season',
    lowSeason: 'Low season',
    customPricing: 'Custom Pricing',
    contactAdvisors: 'Contact our advisors for a personalized quote according to your dates and destinations.',
    availableDestinations: 'Available Destinations',
    mediterranean: 'Mediterranean',
    caribbean: 'Caribbean',
    otherRegions: 'Other Regions',
    
    // Photo Gallery
    photoGallery: 'Photo Gallery',
    discoverDetails: 'Discover Every Detail',
    mainImage: 'Main Image',
    galleryComingSoon: 'Gallery Coming Soon',
    photosAvailableSoon: 'Photos of this yacht will be available soon. Contact us for more information.',
    viewAllPhotos: 'View All Photos',
    
    // CTA
    readyForEscape: 'Ready for Escape?',
    createUniqueExperience: 'Create Your Unique Experience',
    advisorsAccompany: 'Our specialized advisors accompany you in creating a tailor-made journey, adapted to your most demanding desires.',
    bookThisYacht: 'Book This Yacht',
    discoverOtherYachts: 'Discover Other Yachts'
  },
  
  // Search & Filters
  search: {
    searchYachts: 'Search Yachts',
    allDestinations: 'All Destinations',
    allTypes: 'All Types',
    motorYacht: 'Motor Yacht',
    sailingYacht: 'Sailing Yacht',
    catamaran: 'Catamaran',
    explorer: 'Explorer',
    classic: 'Classic'
  },
  
  // Footer
  footer: {
    tagline: 'Private Journeys Perfected',
    description: 'Experience luxury redefined with our curated collection of superyachts.',
    quickLinks: 'Quick Links',
    destinations: 'Destinations',
    contact: 'Contact',
    followUs: 'Follow Us',
    allRightsReserved: 'All rights reserved.'
  },
  
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    tryAgain: 'Try Again',
    close: 'Close',
    next: 'Next',
    previous: 'Previous',
    more: 'More',
    less: 'Less'
  },

  // Pages
  pages: {
    // Escapes/Destinations
    escapes: {
      title: 'Private Escapes',
      subtitle: 'Exclusive Destinations',
      description: 'Discover the world\'s most exclusive yachting destinations, where luxury meets adventure in perfect harmony.',
      ourDestinations: 'Our Destinations',
      exceptionalEscapes: 'Exceptional Escapes',
      exclusiveExperiences: 'Exclusive Experiences',
      beyondTheJourney: 'Beyond the Journey'
    },

    // Experience
    experience: {
      title: 'Experience',
      subtitle: 'Exceptional Experiences',
      description: 'Immerse yourself in unparalleled luxury with our curated experiences.',
      createMyExperience: 'Create My Experience',
      exclusiveArsenal: 'Exclusive Arsenal',
      philosophy: 'Philosophy'
    },

    // Contact
    contact: {
      title: 'Contact Our Specialists',
      subtitle: 'Let\'s Create Your Perfect Escape',
      description: 'Our yacht charter specialists are available 24/7 to craft your personalized luxury experience.',
      contactForm: 'Contact Form',
      contactInformation: 'Contact Information',
      directContact: 'Direct Contact',
      preferredContactMethod: 'Preferred Contact Method',
      sendMessage: 'Send Message',
      messageSent: 'Message sent successfully! We\'ll contact you within 2 hours.',
      messageError: 'Error sending message. Please try again.',
      
      // Form fields
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        service: 'Service Interest',
        budgetRange: 'Budget Range',
        charterDates: 'Preferred Charter Dates',
        message: 'Message & Preferences',
        namePlaceholder: 'Your full name',
        emailPlaceholder: 'your.email@example.com',
        phonePlaceholder: '+1 (555) 123-4567',
        budgetPlaceholder: 'Select your budget range',
        datesPlaceholder: 'When would you like to charter?',
        messagePlaceholder: 'Tell us about your dream yacht experience...'
      },

      // Service options
      services: {
        charter: 'Yacht Charter',
        purchase: 'Yacht Purchase',
        management: 'Yacht Management',
        consultation: 'Private Consultation',
        event: 'Special Events',
        corporate: 'Corporate Charters'
      },

      // Budget ranges
      budgets: {
        '50k-100k': '$50,000 - $100,000',
        '100k-250k': '$100,000 - $250,000',
        '250k-500k': '$250,000 - $500,000',
        '500k-1m': '$500,000 - $1,000,000',
        '1m+': '$1,000,000+'
      }
    }
  }
};

export default translations;
